import React, { useState, useEffect } from "react";
import Layout from "../pages/Layout";
import Advertise from "../pages/Advertise";

export default function ShippingCost() {
  const [baseRate, setBaseRate] = useState("");
  const [weight, setWeight] = useState("");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [costPerKg, setCostPerKg] = useState("");
  const [distanceFactor, setDistanceFactor] = useState("");
  const [discounts, setDiscounts] = useState("");
  const [shippingCost, setShippingCost] = useState(0);

  const convertWeightToKg = (value, unit) => {
    switch (unit) {
      case "quintal":
        return value * 100;
      case "ton":
        return value * 1000;
      default:
        return value;
    }
  };

  const calculateShippingCost = () => {
    const weightInKg = convertWeightToKg(parseFloat(weight) || 0, weightUnit);
    const costBeforeDiscount =
      (parseFloat(baseRate) || 0) +
      weightInKg * (parseFloat(costPerKg) || 0) +
      (parseFloat(distanceFactor) || 0);
    const discountAmount =
      ((parseFloat(discounts) || 0) / 100) * costBeforeDiscount;
    const finalCost = costBeforeDiscount - discountAmount;

    setShippingCost(finalCost.toFixed(2));
  };

  const handleInputChange = (setter) => (e) => {
    const value = e.target.value;
    setter(value.replace(/^0+(?=\d)/, ""));
    calculateShippingCost();
  };

  useEffect(() => {
    const weightInKg = convertWeightToKg(parseFloat(weight) || 0, weightUnit);
    const costBeforeDiscount =
      (parseFloat(baseRate) || 0) +
      weightInKg * (parseFloat(costPerKg) || 0) +
      (parseFloat(distanceFactor) || 0);
    const discountAmount =
      ((parseFloat(discounts) || 0) / 100) * costBeforeDiscount;
    const finalCost = costBeforeDiscount - discountAmount;

    setShippingCost(finalCost.toFixed(2));
  // }, [baseRate, weight, weightUnit, costPerKg, distanceFactor, discounts]);

    // This will initialize or reinitialize all popovers on the page whenever the component renders
    const popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );

    // Clean up any existing popover instances
    popoverTriggerList.forEach((popoverTriggerEl) => {
      const popover = window.bootstrap.Popover.getInstance(popoverTriggerEl); // Check if instance already exists
      if (popover) {
        popover.dispose(); // Dispose of existing popover
      }
    });

    // Re-initialize popovers
    popoverTriggerList.forEach((popoverTriggerEl) => {
      new window.bootstrap.Popover(popoverTriggerEl); // Re-initialize popovers
    });
  }, [baseRate, weight, weightUnit, costPerKg, distanceFactor, discounts]);

  return (
    <Layout title="Shipping Cost Calculator" path="shipping-cost">
      <section
        className="topics-detail-section section-padding"
        id="topics-detail"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-8 mb-4">
              <div
                className="p-4 border rounded shadow"
                style={{ border: "1px solid black" }}
              >
                <h3 className="text-center mb-4 ">Shipping Cost Calculator</h3>
                <div className="container">
                  <div className="row gy-3">
                    <div className="col-md-6 col-lg-4">
                      <label className="form-label">
                        Base Rate (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Base Rate:</strong> The fixed cost of shipping before additional charges."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="baseRate"
                        step="0.01"
                        placeholder="Enter base rate"
                        value={baseRate}
                        onChange={handleInputChange(setBaseRate)}
                      />
                    </div>

                    <div className="col-md-12 col-lg-8">
                      <label className="form-label">
                        Weight
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Weight:</strong> The total weight of the package being shipped. Ensure the correct unit is selected (kg, quintal, ton)."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <div className="d-flex">
                        <input
                          type="number"
                          className="form-control me-2"
                          id="weight"
                          step="0.01"
                          placeholder="Enter weight"
                          value={weight}
                          onChange={handleInputChange(setWeight)}
                        />
                        <select
                          className="form-select"
                          id="weightUnit"
                          value={weightUnit}
                          onChange={(e) => {
                            setWeightUnit(e.target.value);
                            calculateShippingCost();
                          }}
                        >
                          <option value="kg">kg</option>
                          <option value="quintal">quintal</option>
                          <option value="ton">ton</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="costPerKg" className="form-label">
                        Cost per kg (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Cost per kg:</strong> The additional charge applied for each kilogram of weight."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="costPerKg"
                        step="0.01"
                        placeholder="Enter cost per kg"
                        value={costPerKg}
                        onChange={handleInputChange(setCostPerKg)}
                      />
                    </div>

                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="distanceFactor" className="form-label">
                        Distance Factor (₹)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Distance Factor:</strong> Extra cost based on how far the package is traveling."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="distanceFactor"
                        step="0.01"
                        placeholder="Enter distance factor"
                        value={distanceFactor}
                        onChange={handleInputChange(setDistanceFactor)}
                      />
                    </div>

                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="discounts" className="form-label">
                        Discounts (%)
                        <span
                          className="ms-2 text-muted"
                          data-bs-toggle="popover"
                          data-bs-html="true"
                          data-bs-placement="top"
                          data-bs-content="<strong>Discounts:</strong> A percentage reduction applied to the final shipping cost."
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="discounts"
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder="Enter discount percentage"
                        value={discounts}
                        onChange={handleInputChange(setDiscounts)}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <div className="p-3 text-center">
                      <h6>
                        Shipping Cost:{" "}
                        <span id="shippingCost" className="fw-bold ms-3">
                          ₹{shippingCost}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Advertise />
          </div>
        </div>
      </section>
      <section className="introduction-section" id="introduction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-5">
                <h3 className="text-center mb-5">
                  Introduction to the Shipping Cost Calculator
                </h3>

                <h4 className="mt-3 mb-3">
                  What is a Shipping Cost Calculator?
                </h4>
                <p>
                  A <strong>Shipping Cost Calculator</strong> is a tool designed
                  to estimate the cost of shipping goods from one location to
                  another. It considers multiple factors such as the base rate,
                  weight, distance, and optional discounts to provide an
                  accurate estimate. This tool is invaluable for businesses and
                  individuals aiming to budget for shipping expenses
                  effectively.
                </p>

                <h4 className="mt-4 mb-3">How to Calculate Shipping Cost?</h4>
                {/* <p>
                Calculating the shipping cost is straightforward with the following formula:
            </p>
            <blockquote>
                <strong>Shipping Cost</strong> = (Base Rate + (Weight × Cost per kg) + Distance Factor) - Discounts
            </blockquote> */}
                <p>Steps to use the calculator:</p>
                <ul>
                  <li>
                    Input the base rate, representing the fixed initial cost.
                  </li>
                  <li>
                    Enter the weight and select the appropriate unit (kg,
                    quintal, or ton).
                  </li>
                  <li>
                    Specify the cost per kilogram and provide the distance
                    factor.
                  </li>
                  <li>
                    Optionally, apply a discount percentage if applicable.
                  </li>
                </ul>
                <p>
                  The calculator will then process these inputs and instantly
                  display the estimated shipping cost.
                </p>

                <h4 className="mt-4 mb-3">
                  What are the Factors on which Shipping Calculation Depends?
                </h4>
                <p>
                  The accuracy of shipping cost calculations depends on several
                  factors:
                </p>
                <ul>
                  <li>
                    <strong>Base Rate:</strong> The starting fee for shipping
                    services.
                  </li>
                  <li>
                    <strong>Weight:</strong> Total shipment weight, influencing
                    fuel and handling costs.
                  </li>
                  <li>
                    <strong>Cost per kg:</strong> The cost applied per kilogram
                    of the shipment.
                  </li>
                  {/* <li>
                <strong>Distance:</strong> The distance between the origin and destination.
                </li> */}
                  <li>
                    <strong>Distance Factor:</strong> Any added cost related to
                    route complexities or distance.
                  </li>
                  <li>
                    <strong>Discounts:</strong> Reductions applied based on
                    promotions or volume.
                  </li>
                </ul>

                <h4 className="mt-4 mb-3">
                  What are the Benefits of a Shipping Cost Calculator?
                </h4>
                <p>Utilizing a shipping cost calculator offers key benefits:</p>
                <ul>
                  <li>
                    <strong>Accurate Estimates:</strong> Helps users budget
                    accurately for shipping costs.
                  </li>
                  <li>
                    <strong>Efficiency:</strong> Saves time by automating
                    complex calculations.
                  </li>
                  <li>
                    <strong>Better Planning:</strong> Aids in strategic
                    decision-making for shipping and logistics.
                  </li>
                  <li>
                    <strong>Cost Control:</strong> Identifies potential savings
                    through discounts or unit choices.
                  </li>
                </ul>

                <h4 className="mt-4 mb-3">
                  Why Should I Use a Shipping Cost Calculator for My Business?
                </h4>
                <p>
                  Using a Shipping Cost Calculator for your business offers
                  several advantages:
                </p>
                <ul>
                  <li>
                    <strong>Improved Customer Experience:</strong> Provide
                    accurate shipping cost estimates, enhancing customer
                    satisfaction.
                  </li>
                  <li>
                    <strong>Competitive Advantage:</strong> Allow for better
                    pricing strategies and faster response times.
                  </li>
                  <li>
                    <strong>Cost Savings:</strong> Identify the most
                    cost-effective shipping options and routes.
                  </li>
                  <li>
                    <strong>Scalability:</strong> Helps businesses of all sizes
                    manage shipping costs as they grow.
                  </li>
                </ul>

                <p>
                  In summary, the Shipping Cost Calculator is an essential tool
                  for individuals and businesses, simplifying cost estimations
                  and aiding in effective budget management.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
